import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import API from '../api';
import Layout from './Layout';

export default function OrderSearch() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [orderNumber, setOrderNumber] = useState('');
  const [barcode, setBarcode] = useState('');
  const [searchType, setSearchType] = useState('orderNumber');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSearch = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const query = searchType === 'orderNumber' ? orderNumber.trim() : barcode.trim();
      if (!query) {
        setError(t('Please enter a value'));
        return;
      }

      const res = await API.get('orders/');
      const orders = Array.isArray(res.data) ? res.data : [];
      const found = searchType === 'orderNumber'
        ? orders.find((o) => String(o.order_number || '').toLowerCase() === query.toLowerCase())
        : orders.find((o) => String(o.barcode || '').toLowerCase() === query.toLowerCase());

      if (!found) {
        setError(t('Order not found'));
        return;
      }

      navigate(`/tracking/${found.id}`);
    } catch (_) {
      setError(t('Failed to load order'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout title={t('Order Tracking')}>
      <div className="card" style={{ maxWidth: 720 }}>
        <h3 style={{ marginTop: 0, marginBottom: 12 }}>{t('Search for Order')}</h3>
        {error && <p className="login-error">{error}</p>}

        <form onSubmit={handleSearch} className="form-grid">
          <div className="row-actions" style={{ gridColumn: '1 / -1' }}>
            <label>
              <input
                type="radio"
                name="searchType"
                value="orderNumber"
                checked={searchType === 'orderNumber'}
                onChange={(e) => setSearchType(e.target.value)}
              />
              {' '}{t('Order Number')}
            </label>
            <label>
              <input
                type="radio"
                name="searchType"
                value="barcode"
                checked={searchType === 'barcode'}
                onChange={(e) => setSearchType(e.target.value)}
              />
              {' '}{t('Barcode')}
            </label>
          </div>

          {searchType === 'orderNumber' ? (
            <input
              className="input"
              placeholder={t('Enter order number')}
              value={orderNumber}
              onChange={(e) => setOrderNumber(e.target.value)}
            />
          ) : (
            <input
              className="input"
              placeholder={t('Enter barcode')}
              value={barcode}
              onChange={(e) => setBarcode(e.target.value)}
            />
          )}

          <button className="btn btn-primary" type="submit" disabled={loading}>
            {loading ? t('Loading...') : t('Search Order')}
          </button>
        </form>
      </div>
    </Layout>
  );
}
